import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText } from 'lucide-react';
import { RequirementForm } from './RequirementForm';

export const CreateRequirementPage: React.FC = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('/requirements');
  };

  const handleCancel = () => {
    navigate('/requirements');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-background-200 dark:from-[#141414] via-background-100 dark:via-[#1A1A1A] to-background-200 dark:to-[#141414] relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-cyan-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-purple-500/5 rounded-full blur-3xl animate-pulse delay-500"></div>
      </div>

      {/* Main Content Container */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

        {/* Liquid Glassmorphic Form Container */}
        <div className="relative">
          {/* Animated Border */}
          <div className="absolute inset-0 bg-gradient-to-r from-primary-500/20 via-cyan-500/20 to-purple-500/20 rounded-2xl blur-sm animate-gradient-border"></div>
          
          {/* Main Form Container */}
          <div className="relative bg-glass-surface/40 dark:bg-glass-surface-dark-mode/40 backdrop-blur-2xl rounded-2xl border border-glass-border/50 dark:border-glass-border-dark-mode/50 shadow-glass overflow-hidden">
            {/* Liquid Glass Header */}
            <div className="liquid-glass-header px-8 py-6 border-b border-glass-border/30 dark:border-glass-border-dark-mode/30">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="p-2 bg-gradient-to-r from-primary-500/20 to-cyan-500/20 rounded-lg backdrop-blur-xl border border-primary-500/30">
                    <FileText className="w-6 h-6 text-primary-400" />
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-text-enterprise-primary">
                      Job Requirement Details
                    </h2>
                    <p className="text-sm text-text-enterprise-secondary">
                      Fill in the comprehensive details below
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-primary-400 rounded-full animate-pulse"></div>
                  <div className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse delay-100"></div>
                  <div className="w-2 h-2 bg-purple-400 rounded-full animate-pulse delay-200"></div>
                </div>
              </div>
            </div>

            {/* Form Content */}
            <div className="liquid-glass-content">
              <RequirementForm
                mode="create"
                onSuccess={handleSuccess}
                onCancel={handleCancel}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateRequirementPage;
